export enum StreamChatEventsEnum {
	MessageNew = 'stream-chat.message.new',
}
